import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

const disconnect = async (unipileAccountId: string): Promise<void> => {
  await api.post('/ft_unipile/disconnect', { unipileAccountId })
}

export const useUnipileDisconnect = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string>({
    mutationFn: disconnect,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['ft_unipile_accounts'] })
    },
  })
}
